<template>
  <div class="view view__about">
    <h1 class="typography typography--headline1">
      О приложении
    </h1>
    <div class="about">
      Приложение представляет из себя витрину товаров, которая получает данные о товарах из JSON-файла.
      <br>

      JSON-файл содержит массив имеющихся товаров, для каждого из которых задан следующий набор полей:
      <ul>
        <li>
          id - идентификатор товара;
        </li>
        <li>
          name - наименование товара;
        </li>
        <li>
          description - описание товара;
        </li>
        <li>
          price - цена товара;
        </li>
        <li>
          cover - имя файла изображения, являющегося обложкой товара;
        </li>
        <li>
          images - массив, содержащий все имена файлов с изображениями товара (файлы изображений, как и сам JSON-файл должны располагаться локально).
        </li>
      </ul>

      Получив данные из JSON-файла витрина случайным образом отображает до 10 товаров, т.е. может быть и 1 товар, и 2, и 3..., и 10,
      и это происходит каждый раз, когда пользователь открывает витрину.
      <br>
      При этом витрина подстраивается под количество отображаемых товаров:
      <ul>
        <li>
          Если товар один, то блок товара растягивается на всю страницу;
        </li>
        <li>
          Если товаров два или три, то блоки товаров отображаются несколькими колонками;
        </li>
        <li>
          Если же товаров больше трёх, то блоки товаров отображаются слайдером с прокруткой;
        </li>
      </ul>

      Каждый блок товара на витрине удовлетворяет следующим требованиям:
      <ul>
        <li>
          В блоке отображается обложка товара;
        </li>
        <li>
          Его наименование;
        </li>
        <li>
          И цена;
        </li>
        <li>
          При клике на товар осуществляется переход из витрины к карточке товара;
        </li>
        <li>
          Также имеется возможность добавления товара в корзину и удаления из корзины.
        </li>
      </ul>

      Карточка товара является отдельной страницей приложения, которая помимо перечисленных выше требований удовлетворяет еще нескольким:
      <ul>
        <li>
          Карточка товара содержит еще и его описание;
        </li>
        <li>
          А также все доступные изображения товара;
        </li>
        <li>
          Из карточки товара есть возможность его добавления в корзину, и удаления из корзины.
        </li>
      </ul>

      У пользователя приложения есть возможность открыть корзину как со страницы витрины товаров, так и из карточки товара.
      <br>
      При этом корзина соответствует своим требованиям:
      <ul>
        <li>
          Она открывается в модальном окне;
        </li>
        <li>
          Отображает все добавленные позиции, с их обложками, наименованием и ценой, а также общую стоимость всех позиций;
        </li>
        <li>
          По каждой позиции есть возможность изменение количества единиц заказанной позиции, и возможность её удаления из корзины;
        </li>
        <li>
          Из корзины есть возможность распечатать все добавленные позиции;
        </li>
        <li>
          И наконец есть возможность закрытия модального окна корзины;
        </li>
        <li>
          Кроме того состояние корзины сохраняется в localStorage, чтобы добавленные позиции не терялись,
          когда пользователь закрывает приложение и возвращается спустя какое-то время.
          Предусмотрена и очистка устаревших данных из localStorage, чтобы они не мешали нормальной работе приложения при его обновлениях.
        </li>
      </ul>

      Приложение реализовано на single-page framework-е <a class="link" href="https://vuejs.org/">Vue.js</a>.
      <br>
      Работа с состоянием реализована через <a class="link" href="https://vuex.vuejs.org/">Vuex</a> - это реализация
      <a class="link" href="https://www.freecodecamp.org/news/an-introduction-to-the-flux-architectural-pattern-674ea74775c9/">Flux</a>
      для <a class="link" href="https://vuejs.org/">Vue.js</a>.
      <br>
      Приложение свёрстано под разрешение 1280x800 (адаптивная вёрстка не требовалась).
    </div>
  </div>
</template>

<script>
export default {
  name: 'about'
};
</script>

<style lang="scss">
@import '@/styles/blocks/about/variables';

@import '@/styles/blocks/about/about';
</style>
